import axios from "axios";
import { cmsEnv, headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/custom/useToast";

export const CompanyDetails = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/company-details`,
      {
        headers: {
          ...headers,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(error.response.data.error.message);
  }
};
